@if (text && !svgIcon) {
    <mat-icon
        [matTooltipClass]="'light-tooltip'"
        [matTooltipPosition]="'right'"
        [matTooltip]="text"
        class="no-print"
        #tooltip="matTooltip"
        (click)="tooltip.show()">
        {{ icon }}
    </mat-icon>
}
@if (text && svgIcon) {
    <mat-icon
        [matTooltipClass]="'light-tooltip'"
        [matTooltipPosition]="'right'"
        [matTooltip]="text"
        class="no-print"
        [svgIcon]="svgIcon"
        #tooltip="matTooltip"
        (click)="tooltip.show()">
    </mat-icon>
}
